<template lang="html">
  <div class="drag-and-drop column" :class="{dragging: isDragging}" @click="fileInput" ref="master">
		<span class="icon-form-plus" v-if="!file"></span>
		<div class="label" v-if="!file">
			Déposer votre fichier
		</div>
		<div class="ctn-file column" v-else>
			<div class="ctn-icon-document">
				<img :src="baseFile" alt="">
				<span class="extension">.{{ file.name | uppercase }}</span>
			</div>
			<div class="file-name">
				{{ file.name }}
			</div>
		</div>
		<input id="input-file" type="file" @change="setFile"/>
  </div>
</template>

<script>
import BaseFile from '@/common/assets/img/icon.svg'
export default {
	name: 'drag-and-drop',
	props: ['value'],
	data () {
		return {
			isDragging: false,
			file: null,
			baseFile: BaseFile
		}
	},
	mounted () {
		window.addEventListener('dragover', this.drag)
		window.addEventListener('dragleave', this.undrag)
		window.addEventListener('drop', this.drop)
	},
	filters: {
		uppercase: (value) => {
			return value.split('.')[value.split('.').length - 1].toUpperCase()
		}
	},
	methods: {
		drop (e) {
			e.preventDefault()
			this.isDragging = false
			const droppedFiles = e.dataTransfer.items || e.dataTransfer.files
			Object.keys(droppedFiles).forEach((key) => {
				this.file = droppedFiles[key].getAsFile()
				this.$emit('input', this.file)
			})
		},
		drag (e) {
			e.preventDefault()
			this.isDragging = true
		},
		undrag (e) {
			e.preventDefault()
			this.isDragging = false
		},
		fileInput () {
			this.$refs.master.lastChild.click()
		},
		setFile (e) {
			Object.keys(e.target.files).forEach((key) => {
				this.file = e.target.files[key]
				this.$emit('input', this.file)
			})
		}
	},
	beforeDestroy () {
		window.removeEventListener('dragover', this.drag)
		window.removeEventListener('dragleave', this.undrag)
		window.removeEventListener('drop', this.drop)
	}
}
</script>

<style lang="scss" scoped>
$grey: #9b9b9b;
$green: #01df85;

#input-file {
	display: none;
}

.drag-and-drop {
	cursor: pointer;
	width: 100%;
	padding: 2rem 0;
	border: 2px dashed rgba($grey, 0.4);

	&.dragging {
		border-color: $green;
	}

	span {
		color: $grey;
		font-size: 1.5rem;
	}

	.label {
		margin-top: 0.5rem;
		color: $grey;
		font-size: 0.8rem;
	}

	.ctn-file {
		.file-name {
			font-size: 0.8rem;
		}
	}

	.ctn-icon-document {
		.extension {
			font-size: 0.8rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// DragAndDrop.vue?569a0dc7